import React from 'react';
import {
  Frame,
  Page,
  Layout,
  Link,
  BlockStack,
  Button,
  Text,
  Card,
  Box,
} from '@shopify/polaris';
import { css } from '@emotion/css';
import * as FullStory from '@fullstory/browser';

const mailToLinkWithError = ({ statusCode }) => {
  return `mailto:support@awtomic.com?subject=Error%20Occurred&body=Dear%20Awtomic%20Support%20-%0D%0A%0D%0AI%20ran%20into%20a%20${statusCode}%20error.%20Here%20are%20more%20details%3A%0D%0A%0D%0A`;
};

function ErrorComponent({ statusCode }) {
  console.error(`Error occurred with status code: ${statusCode}`);

  if (typeof window !== 'undefined') {
    window.Intercom('trackEvent', 'Error Page', {
      'Status Code': statusCode,
      'Full Story Session Link': FullStory.getCurrentSessionURL(true),
    });
  }

  return (
    <Frame>
      <Page>
        <Layout>
          <Layout.Section>
            <div className={styles.card}>
              <Card>
                <Box>
                  <BlockStack gap="400">
                    <Text variant="headingMd" as="h2">
                      An error occurred
                    </Text>
                    <p>
                      Please try to re-open the app and if this continues to
                      happen, contact{' '}
                      <Link url={mailToLinkWithError({ statusCode })} external>
                        support@awtomic.com
                      </Link>
                    </p>
                    <Button url={mailToLinkWithError({ statusCode })} external>
                      Contact Support
                    </Button>
                  </BlockStack>
                </Box>
              </Card>
            </div>
          </Layout.Section>
        </Layout>
      </Page>
    </Frame>
  );
}

const styles = {
  card: css`
    margin-top: 30px;
    text-align: center;
  `,
};

export default ErrorComponent;
